module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackCondIt.a452933.woff";